import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import checkoutReducer from "./slices/checkout";
import userProviderReducer from "./slices/userProvider";
import newReduxTestReducer from "./slices/newReduxTest";

// ----------------------------------------------------------------------

const checkoutPersistConfig = {
  key: "checkout",
  storage,
  keyPrefix: "redux-",
};

const rootReducer = combineReducers({
  checkout: persistReducer(checkoutPersistConfig, checkoutReducer),
  userProvider: userProviderReducer,
  newReduxTest: newReduxTestReducer,
});

export default rootReducer;
